import { TextField } from 'mui-rff';
import React from 'react';

import Form from '@dashboard/components/form/Form';
import IconButtonLink from '@dashboard/components/mui-atoms/IconButtonLink';
import { useCreateApiKeyMutation } from '@dashboard/generated/wp/platform';
import usePlatformNavigator from '@dashboard/hooks/navigate/usePlatformNavigator';
import useCurrentPlatformId from '@dashboard/hooks/route/useCurrentPlatformId';
import { ArrowBackOutlined } from '@mui/icons-material';
import { Box, Button, Grid, Paper, Stack, Typography } from '@mui/material';

import PermissionTooltip from '../../components/PermissionTooltip';

import { usePermission } from './PlatformSettingsPage/hooks';

export default function PlatformApiKeyNew() {
  const [mutation, { loading }] = useCreateApiKeyMutation();
  const navigator = usePlatformNavigator();
  const permission = usePermission('createApiKey');
  const platformId = useCurrentPlatformId();

  async function onSubmit(form: { name: string | undefined | null }) {
    await mutation({ variables: { name: form.name || '' } });
    navigator.platformSettings();
  }

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid item xs={12} md={10} lg={8} xl={7}>
        <Paper sx={{ p: 4 }}>
          <Stack spacing={2}>
            <Box>
              <IconButtonLink href={`/o/${platformId}/settings`} edge="start">
                <ArrowBackOutlined />
              </IconButtonLink>
            </Box>
            <Typography variant="h3" component="h1">
              Create a new API key
            </Typography>
            <Form onSubmit={onSubmit}>
              <TextField
                autoFocus
                disabled={loading}
                name="name"
                label="Label"
                helperText="A descriptive name for your API key."
                fullWidth
                margin="normal"
              />
              <Box mt={5}>
                <PermissionTooltip span name="createApiKey">
                  <Button size="large" disabled={loading || !permission} type="submit" variant="contained">
                    Create API key
                  </Button>
                </PermissionTooltip>
              </Box>
            </Form>
          </Stack>
        </Paper>
      </Grid>
    </Grid>
  );
}
